import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { UsuarioService } from '../../../../services/usuario.service';

import { User } from 'src/app/models/user.model';
import Swal from 'sweetalert2';
import { SignaturePadComponent as LibSignaturePadComponent } from '@almothafar/angular-signature-pad';
import { PerfilUserResult } from '../presenter/interfaces/perfil-user.result';
import { IsRequestComplete } from 'src/app/interfaces/isrequest-complete';
import { PerfilUserRequest } from '../presenter/interfaces/perfil-user.request';
import { PerfilUserPresenter } from '../presenter/perfil-user.presenter';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { getRoleName } from '../../../../utilities/role-utilities';


@Component({
    selector: 'app-perfil',
    templateUrl: './perfil.component.html',
    styleUrls: ['./perfil.component.scss'],
    standalone: false
})
export class PerfilComponent implements PerfilUserResult, IsRequestComplete, OnInit {
  getRoleName = getRoleName;


  @ViewChild('signature') signaturePad!: LibSignaturePadComponent;

  public perfilForm!: UntypedFormGroup;
  public formUpdatePassword!: UntypedFormGroup;
  public usuario: User;
  public imagenSubir!: File;
  public imgTemp: any = null;
  public watchFormPassword: boolean = false;
  public watchFormProfile: boolean = true;



  signatureHide: boolean = false;
  signaturePadOptions: Object = {
    'minWidth': 1,
    'canvasWidth': 400,
    'canvasHeight': 200,

  };

  request: PerfilUserRequest;

  constructor(private fb: UntypedFormBuilder,
    private usuarioService: UsuarioService,
    private toastr: ToastrService,
    private perfilUserPresenter: PerfilUserPresenter) {

    this.request = perfilUserPresenter;
    perfilUserPresenter.setRequestCompleteComponent(this);
    perfilUserPresenter.setComponent(this);

    this.usuario = usuarioService.usuario;

  }

  ngOnInit(): void {

    this.perfilForm = this.fb.group({
      name: [this.usuario.name, Validators.required],
      email: [this.usuario.email, [Validators.required, Validators.email]],
      signature: [this.usuario.signature ? this.usuario.signature : ''],
      signature_date: [this.usuario.signature_date ? this.usuario.signature_date : '',]
    });

    this.getFormUpdatePassword();
  }

  isRequestComplete(status: boolean, error?: HttpErrorResponse): void {
    (status) ? this.toastr.success('Updated User') : this.toastr.error(error?.error?.msg);
  }
  isEditedResponse(response: any): void {
    response.user.imagenUrl = this.usuario.imagenUrl
    this.usuario = response.user;
    this.request.setUserPerfil(response.user);
  }
  isUpdatedPasswordResponse(response: any): void {
    this.formUpdatePassword.reset();
    Swal.fire('Updated', `${response.msg}`, 'success');
  }

  getImageSubir(file: any): void {
    this.imagenSubir = file;
  }
  getImgTmp(file: any): void {
    this.imgTemp = file;
  }


  getFormUpdatePassword() {
    this.formUpdatePassword = this.fb.group({
      password: ['', Validators.required],
      passwordRepeat: ['', Validators.required],
    });
  }
  get passwordNoValid() {
    const pass1 = this.formUpdatePassword.get('password')?.value;
    const pass2 = this.formUpdatePassword.get('passwordRepeat')?.value;
    return (pass1 === pass2) ? false : true;
  }



  actualizarPerfil() {
    this.request.updatePerfil(this.perfilForm.value);
    this.setFormData();
  }


  cambiarImagen(file: File) {
    this.request.changeImage(file);
  }

  subirImagen() {
    this.request.uploadImage(this.usuario);
  }

  setFormData() {
    const { nombre, email, signature, signature_date } = this.perfilForm.value;
    this.usuario.name = nombre;
    this.usuario.email = email;
    this.usuario.signature = signature;
    this.usuario.signature_date = signature_date;
  }

  ngAfterViewInit() {

    // this.signaturePad.set('minWidth', 1);
    // this.signaturePad.set('backgroundColor', '#FFFFFF');
    this.signaturePad.clear();
  }

  drawComplete() {
    this.perfilForm.get('signature')?.setValue(this.signaturePad.toDataURL());
    this.perfilForm.get('signature_date')?.setValue(new Date().toLocaleDateString());
  }

  drawStart() {
    console.log('begin drawing');
  }

  clearPad() {
    this.signaturePad.clear();
    this.perfilForm.get('signature')?.setValue(this.usuario.signature);
    this.perfilForm.get('signature_date')?.setValue(this.usuario.signature_date);
  }
  updatePassword() {
    this.request.updatePasword(this.formUpdatePassword.value.passwordRepeat);
  }
  watchForms() {
    this.formUpdatePassword.reset();
    this.watchFormPassword ? this.watchFormPassword = false : this.watchFormPassword = true;
    this.watchFormProfile ? this.watchFormProfile = false : this.watchFormProfile = true;
  }

}
